import { StudioShooting } from '../studio/StudioShooting';
import type { CircleFormState } from '../studio/circle/CircleFieldInput';
export function PhotoShooting({ state }: { state: CircleFormState }) {
  return <StudioShooting state={state} />;
}
